export default {
  driver_performance_driver_filters_timeFrame: "Periodo de tiempo",
  driver_performance_driver_filters_events: "Eventos",
  driver_performance_driver_filters_drivers: "Conductores",
  driver_performance_driver_filters_tags: "Etiquetas",
  driver_performance_driver_filters_configuring: "Configurando",
  driver_performance_driver_filters_riskScore: "Puntuación de Riesgo",
};